/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './UsageBasedBillingExperienceRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getCurrentUsageAndLimit
 */
export const GET_CURRENT_USAGE_AND_LIMIT_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getCurrentUsageAndLimit';
export const GET_CURRENT_USAGE_AND_LIMIT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CURRENT_USAGE_AND_LIMIT_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getCurrentUsageAndLimitRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getUsagePeriodUsage
 */
export const GET_USAGE_PERIOD_USAGE_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getUsagePeriodUsage';
export const GET_USAGE_PERIOD_USAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USAGE_PERIOD_USAGE_QUERY_FIELD_NAME,
  args: ['showBreakdown'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getUsagePeriodUsageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getNonChargeableUsagePeriodUsage
 */
export const GET_NON_CHARGEABLE_USAGE_PERIOD_USAGE_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getNonChargeableUsagePeriodUsage';
export const GET_NON_CHARGEABLE_USAGE_PERIOD_USAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_NON_CHARGEABLE_USAGE_PERIOD_USAGE_QUERY_FIELD_NAME,
  args: ['showBreakdown'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getNonChargeableUsagePeriodUsageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getHistoricalUsagePeriodUsage
 */
export const GET_HISTORICAL_USAGE_PERIOD_USAGE_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getHistoricalUsagePeriodUsage';
export const GET_HISTORICAL_USAGE_PERIOD_USAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HISTORICAL_USAGE_PERIOD_USAGE_QUERY_FIELD_NAME,
  args: ['timeFrame'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getHistoricalUsagePeriodUsageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getHistoricalNonChargeableUsagePeriodUsage
 */
export const GET_HISTORICAL_NON_CHARGEABLE_USAGE_PERIOD_USAGE_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getHistoricalNonChargeableUsagePeriodUsage';
export const GET_HISTORICAL_NON_CHARGEABLE_USAGE_PERIOD_USAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HISTORICAL_NON_CHARGEABLE_USAGE_PERIOD_USAGE_QUERY_FIELD_NAME,
  args: ['timeFrame'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getHistoricalNonChargeableUsagePeriodUsageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getHistoricalByFeatureCategory
 */
export const GET_HISTORICAL_BY_FEATURE_CATEGORY_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getHistoricalByFeatureCategory';
export const GET_HISTORICAL_BY_FEATURE_CATEGORY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HISTORICAL_BY_FEATURE_CATEGORY_QUERY_FIELD_NAME,
  args: ['timeFrame'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getHistoricalByFeatureCategoryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getNonChargeableHistoricalByFeatureCategory
 */
export const GET_NON_CHARGEABLE_HISTORICAL_BY_FEATURE_CATEGORY_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getNonChargeableHistoricalByFeatureCategory';
export const GET_NON_CHARGEABLE_HISTORICAL_BY_FEATURE_CATEGORY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_NON_CHARGEABLE_HISTORICAL_BY_FEATURE_CATEGORY_QUERY_FIELD_NAME,
  args: ['timeFrame'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getNonChargeableHistoricalByFeatureCategoryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getAllBillableMetricChargingEligibility
 */
export const GET_ALL_BILLABLE_METRIC_CHARGING_ELIGIBILITY_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getAllBillableMetricChargingEligibility';
export const GET_ALL_BILLABLE_METRIC_CHARGING_ELIGIBILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_BILLABLE_METRIC_CHARGING_ELIGIBILITY_QUERY_FIELD_NAME,
  args: ['evaluateOnDate'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getAllBillableMetricChargingEligibilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getHistoricalByBillableMetricType
 */
export const GET_HISTORICAL_BY_BILLABLE_METRIC_TYPE_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getHistoricalByBillableMetricType';
export const GET_HISTORICAL_BY_BILLABLE_METRIC_TYPE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HISTORICAL_BY_BILLABLE_METRIC_TYPE_QUERY_FIELD_NAME,
  args: ['startDate', 'endDate'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getHistoricalByBillableMetricTypeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getRateCard
 */
export const GET_RATE_CARD_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getRateCard';
export const GET_RATE_CARD_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_RATE_CARD_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getRateCardRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc#getHubSpotCreditsOveragesCost
 */
export const GET_HUB_SPOT_CREDITS_OVERAGES_COST_QUERY_FIELD_NAME = 'com_hubspot_usagebasedbilling_experience_rpc_UsageBasedBillingExperienceRpc_getHubSpotCreditsOveragesCost';
export const GET_HUB_SPOT_CREDITS_OVERAGES_COST_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HUB_SPOT_CREDITS_OVERAGES_COST_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getHubSpotCreditsOveragesCostRpc, {
      timeout: ctx.timeout
    });
  }
});